module.exports = __webpack_public_path__ + "img/self-doubt.c46d6bd2.svg";